<script lang="ts">
	import { page } from "$app/stores";
	import { AlertType, type Alert } from "$lib/serv/toast";
	import LazyImage from "./LazyImage.svelte";

	export let alert: Alert;

	const getIcon = (type: AlertType) => {
		switch (type) {
			case AlertType.Success:
				return 'icon-check-20';
			case AlertType.Error:
				return 'icon-alert-20';
			case AlertType.Info:
				return 'icon-info-20';
			default: 
				return null;
		}
	}
</script>

<div
	class="alert {alert.type} flex mobile justify-start align-center small-gap shadow-elevation-6dp"
	class:align-center={alert.type === AlertType.Action || alert.image}
>

	{#if alert.image}
		<div class="image">
			<LazyImage image={[alert.image]} alt={alert.title} />
		</div>
	{:else if getIcon(alert.type)}
		<div class="round"><span class={getIcon(alert.type)}></span></div>
	{/if}

	<div class="m-0 fill-space">
		{#if alert.title}<div class="label-xl medium">{alert.title}</div>{/if}
		{#if alert.message}<div class="label-m book">{alert.message}</div>{/if}
	</div>

	{#if alert.type === AlertType.Action || alert.onDismiss}
		{#if typeof alert.onDismiss === 'string'}
			<a href={alert.onDismiss} class="button secondary">{alert.button}</a>
		{:else if typeof alert.onDismiss === 'function'}
			{#if alert.button}
				<button class="button secondary" on:click={alert.onDismiss}>{alert.button}</button>
			{:else}
				<button class="circle" on:click={alert.onDismiss}><span class="icon-close-14"></span></button>
			{/if}
		{:else}
			<a href={$page.url.toString()} class="button secondary" data-sveltekit-reload>Refresh</a>
		{/if}
	{/if}

</div>

<style lang="scss">
	@use 'color';
	@use 'margin';
	@use 'padding';
	@use 'layout';

	.alert {
		@include margin.small;
		@include padding.small;

		background-color: color.$background-elevation-12dp;
		border: 1px solid color.$separator;
		border-left: 4px solid color.$primary-variant;
		border-radius: layout.$border-radius;
		color: color.$on-surface;
		.round { 
				width: 30px;
				height: 30px;
				background: color.$on-background-low-importance;
				border-radius: 50%;
				display: flex;
				justify-content: center;
				align-items: center;
				& > [class^='icon-'] {
					color: color.$white;
					margin: 3px 0;
				}
			}
		

		&.success {
			border-left-color: color.$success;
			.round { background: color.$success; }
		}
		&.error {
			border-left-color: color.$error;
			.round { background: color.$error; }
		}
		&.action { border-left-color: color.$primary-variant; }
		&.info { border-left-color: color.$primary-variant; }
		&.product { border-left-color: color.$primary-variant; }
	}

	.image {
		width: 50px;
		height: 50px;
		border-radius: 8px;
		overflow: hidden;
		margin-right: 10px;
	}

	.m-0 {
		[class^='label'] { margin: 0; }
	}

	.button {
		padding: 4px 14px;
	}

	.circle{
		width: 24px;
		height: 24px;
		border-radius: 24px;
		cursor: pointer;

		span { line-height: 26px; }

		&:hover { background-color: color.$background-elevation-3dp }
		&:active { background-color: color.$background-elevation-6dp; color: color.$on-background-medium-importance; }
	}
</style>